const estimatedYAxisTickCharacterWidth = 8;

type EstimateStackedBarChartYAxisWidthParams = {
  extraLeftGutter: number;
  labels: string[];
  padding: number;
  yAxisLabelOffset: number;
  yAxisWidth: number;
};

export const estimateStackedBarChartYAxisWidth = ({
  extraLeftGutter,
  labels,
  padding,
  yAxisLabelOffset,
  yAxisWidth,
}: EstimateStackedBarChartYAxisWidthParams): number => {
  const longestLabelLength = labels.reduce(
    (maxLength, label) => Math.max(maxLength, label.length),
    0,
  );
  const estimatedLabelWidth = longestLabelLength * estimatedYAxisTickCharacterWidth;
  return Math.max(
    yAxisWidth,
    Math.ceil(estimatedLabelWidth + Math.abs(yAxisLabelOffset) + padding + extraLeftGutter),
  );
};
